import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Subscription } from 'rxjs/Subscription';
import { BroadcastMessageService } from '../../../services/broadcastMessageService';
import { AppService } from '../../../app/app.service';
import { PageContentService } from '../../../services/pagecontent.service';
import { Settings, AppSettings } from '../../../app/app.settings';
import { Router } from '@angular/router';
import { FacebookService, InitParams } from 'ngx-facebook';
import { Observable, Observer } from 'rxjs';


@Component({
    selector: 'app-our-agents',
    templateUrl: './our-agents.component.html',
    styleUrls: ['./our-agents.component.scss'],
    providers: [PageContentService],
})
export class OurAgentsComponent implements AfterViewInit, OnInit {
    public settings: Settings;
    public agents;
    public gallery;
    public tempInnerGallery;
    public galleryId;
    public langId: number;
    subscription: Subscription;
    public config: SwiperConfigInterface = {};
    totalservices: any;
    totalcentres: any;
    previousyearservedcount: any;
    curretnyearservedcount: any;
    currentyear: any;
    previouyear: any;
    eventDate: any;
    projectList: [];
    public tempGallery: any;
    public number: number = 55;
    public number1: number = 174;
    public number2: number = 7;
    public number3: number = 7;
    public number4: number = 7;
    public number5: number = 780;
    public number6: number = 1797;
    public number7: number = 16;
    public number8: number = 211;
    public number9: number = 216;
    public number10: number = 85;
    public number11: number = 15;
    public number12: number = 89;
    public number13: number = 12;
    public number14: number = 3;
    public number15: number = 32;
    public number16: number = 16;
    public observable: Observable<boolean>;
    private observer: Observer<boolean>;
    imageObject: Array<object> = [

        {
            image: 'assets/images/links/testi10.png',
            thumbImage: 'assets/images/links/testi10.png',
            alt: 'Government of TamilNadu',
            title:'Government of TamilNadu',
            url: 'https://www.tn.gov.in/'
        },

        {
            image: 'assets/images/links/testi15.png',
            thumbImage: 'assets/images/links/testi15.png',
            alt: 'State Institute of Rural Development',
            title:'State Institute of Rural Development',
            url: 'http://www.nrhmtn.gov.in/'
        },

        {
            image:'assets/images/links/newtesti20.png',
            thumbImage: 'assets/images/links/newtesti20.png',
            alt: 'National AIDS Control Organisation',
            title:'National AIDS Control Organisation',
            url: 'http://naco.gov.in/'
            
           
        },
        

        {
            image: 'assets/images/links/UnAidslogo.png',
            thumbImage: 'assets/images/links/UnAidslogo.png',
            alt: 'United Nations Programmes on HIV',
            title:'United Nations Programmes on HIV',
            url: 'https://www.unaids.org/en'
            

        },
        {
            image: 'assets/images/links/WHO_Logo.png',
            thumbImage: 'assets/images/links/WHO_Logo.png',
            alt: 'World Health Organization',
            title:'World Health Organization',
            url:'https://www.who.int/'
,
        },
        
        

        
        
    ]
    constructor(public appService: AppService, public pageservice: PageContentService,
        private broadcastMessageService: BroadcastMessageService, private fb: FacebookService,
        public router: Router,
        public appSettings: AppSettings) {
            // this.observable = new Observable<boolean>((observer: any) => this.observer = observer).share();
            // Trigger odometer after 2s
            // setTimeout(() => this.observer.next(true), 2000);

        this.settings = this.appSettings.settings;
        this.subscription = this.broadcastMessageService.getMessage().subscribe(message => {
            this.langId = +message.text;
            // this.pageservice.getLatestNews(this.langId).subscribe(result => {
            //     if (result != null && result !== undefined) {
            //         this.agents = result;
            //     }
            // });
            this.pageservice.getPublicationList(this.langId).subscribe(result => {
                if (result != null && result != undefined) {
                    this.projectList = result.filter(item => item.title === 'Documents');
                }
            });
            this.pageservice.getGalleryList(null, 1).subscribe(result => {
                if (result != null && result !== undefined) {
                    result = result.filter(item => item.name !== 'DAPCU' && item.name !== 'IEC Materials' && item.name !== 'Press Release' && item.name !== 'Memes' && item.name !== 'WBDD Quiz 2020');
                    this.tempGallery = [];
                    result.forEach(item => {
                        this.tempInnerGallery = item.galleryMapping[0].filePath;
                        this.galleryId = item.galleryMapping[0].gallery_Id;
                        let gallery = {
                            id: item.id,
                            name: item.name,
                            description: item.description,
                            eventdate: item.eventdate,
                            details: item.details,
                            filePath: this.tempInnerGallery,
                            gallery_Id: this.galleryId
    
                        }
                        this.tempGallery.push(gallery);
                    })
                   
                }
            });
        });
      
    }

    ngOnInit() {
        this.langId = this.settings.langId;
        this.getLatestNewsList();
        this.getAdvertisement();
        //this.getStatisticalData();
        this.getGalleryList();
        (<any>window).twttr.widgets.load();
        this.config = {
            observer: true,
            slidesPerView: 3,
            spaceBetween: 8,
            keyboard: true,
            navigation: true,
            pagination: true,
            grabCursor: true,
            loop: false,
            preloadImages: false,
            lazy: true,
            breakpoints: {
                600: {
                    slidesPerView: 1,
                },
                960: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 3,
                }
            }
        }

    }



    getLatestNewsList() {
    
        this.langId = this.settings.langId;
        this.pageservice.getLatestNews(this.langId).subscribe(result => {
            if (result != null && result !== undefined) {
                
                this.agents = result.reverse();
            }
        });
    }

    getAdvertisement() {
        this.langId = this.settings.langId;
        this.pageservice.getPublicationList(this.langId).subscribe(result => {
            if (result != null && result != undefined) {
                this.projectList = result.filter(item => item.title === 'Documents').reverse();
            }
        });
    }


    getGalleryList() {
        this.langId = this.settings.langId;
        this.pageservice.getGalleryList(null, 1).subscribe(result => {
            if (result != null && result !== undefined) {
                
                //result = result.filter(item => item.name === 'SLFMC'); 

                // this.gallery = result;
                //this.gallery = result[0].gallerymapping;
                //this.eventdate = result[0].eventdate;
                result = result.filter(item => item.name !== 'DAPCU' && item.name !== 'IEC Materials' && item.name !== 'Press Release' && item.name !== 'Memes' && item.name !== 'WBDD Quiz 2020');
                this.tempGallery = [];
                result.forEach(item => {
                    this.tempInnerGallery = item.galleryMapping[0].filePath;
                    this.galleryId = item.galleryMapping[0].gallery_Id;
                    let gallery = {
                        id: item.id,
                        name: item.name,
                        description: item.description,
                        eventdate: item.eventdate,
                        details: item.details,
                        filePath: this.tempInnerGallery,
                        gallery_Id: this.galleryId

                    }
                    this.tempGallery.push(gallery);
                })
                
            }
        });
    }


    getStatisticalData() {
        this.pageservice.getStatisticalData().subscribe(result => {
            if (result != null && result !== undefined) {

                var statsdata = result[0];
                this.totalservices = statsdata.service;
                this.totalcentres = statsdata.cscs;
                this.previousyearservedcount = statsdata.servedLastYearwebformat;
                this.curretnyearservedcount = statsdata.servedCurrentYearwebformat;
                this.currentyear = statsdata.currentyear;
                this.previouyear = statsdata.perviousYear;

            }
        });
    }

    ngAfterViewInit() {
        this.config = {
            observer: true,
            slidesPerView: 1,
            spaceBetween: 16,
            keyboard: true,
            navigation: true,
            pagination: false,
            grabCursor: true,
            loop: false,
            preloadImages: false,
            lazy: true,
            breakpoints: {
                600: {
                    slidesPerView: 1,
                },
                960: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 3,
                }
            }
        };
    }


    onReadMore() {
        this.router.navigate(['/readmore']);
    }


}
